import { MerchantUserDto } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import { Avatar, Group, MantineSize, Stack, Text } from "@mantine/core";

export type Team = {
  id: number;
  name: string;
  phoneNumber: string;
  profileImage: string;
  description: string;
  firstName: string;
  lastName: string;
};

type Props = {
  team: MerchantUserDto;
  size?: MantineSize;
};

function ScheduleItem({ team, size }: Props) {
  const { imageUrl } = useGetImage({ image: team?.image });

  return size === "sm" ? (


    <Group justify="center" wrap="nowrap" >
      <Avatar
        variant="outline"
        color="blue"
        radius="xl"
        size="md"
        p="2"
        styles={{
          image: {
            borderRadius: "100px",
          },
          root: {
            border: `3px solid ${team?.calendarColor}`,
          },
        }}
        src={imageUrl}
      >
        {team?.firstName?.charAt(0) || ""}
      </Avatar>

      {/* <Avatar color="blue" radius="sm">
        <GenderAvatar gender={customer?.gender} />
      </Avatar> */}
      <Stack
        gap="0"
        justify="center"


      >
        <Text size="xs" lineClamp={1}>
          {team.firstName} {team?.lastName}
        </Text>

        <Text size="xs" c="gray" lineClamp={1}>
          {team?.jobTitle && team?.jobTitle != "undefined" ? team?.jobTitle : ""}
        </Text>
      </Stack>
    </Group>


  ) : (

    <Group justify="space-between">
      <Group>
        <Avatar
          variant="outline"
          color="blue"
          radius="xl"
          size="lg"
          p="2"
          styles={{
            image: {
              borderRadius: "100px",
            },
            root: {
              border: `3px solid ${team?.calendarColor}`,
            },
          }}
          src={imageUrl}
        >
          {team?.firstName?.charAt(0) || ""}
        </Avatar>

        {/* <Avatar color="blue" radius="sm">
        <GenderAvatar gender={customer?.gender} />
      </Avatar> */}
        <Stack gap="0">
          <Text size="md">
            {team.firstName} {team?.lastName}
          </Text>
          {
            <Text size="xs" c="gray">
              {team?.jobTitle || ""}
            </Text>
          }
        </Stack>
      </Group>
    </Group>

  );
}

export default ScheduleItem;
